<ng-container *ngrxLet="newTasks$ as newTasks">
  <ng-container *ngrxLet="reviewedTasks$ as reviewedTasks">
    <div class="tasks-container" *ngrxLet="filters$ as filters">
      <div class="tasks-head">
        @if (showHeader) {
          <div class="flex-grow-1 row justify-content-start align-items-center">
            <h2 class="col-auto pe-0 mb-0">
              {{ "TASKS.PENDING_TASKS" | translate }}
              @if (
                (newTasks.length || reviewedTasks.length) &&
                !(isLoading$ | async)
              ) {
                <span>({{ newTasks.length + reviewedTasks.length }})</span>
              }
            </h2>
            <div class="d-flex col flex-wrap filters-bar p-0">
              @for (filter of filters; track filter) {
                <span
                  class="filter"
                  (click)="removeFilter(filter.fieldName, filter.value)"
                >
                  <span
                    class="align-items-center text-truncate"
                    style="max-width: 500px"
                  >
                    {{ filter.displayName }}
                  </span>
                  <span>
                    <svg-icon [name]="'cross'"></svg-icon>
                  </span>
                </span>
              }
              @if (filters.length) {
                <span (click)="removeAllFilters()" class="remove-filters">{{
                  "TASKS.REMOVE_ALL_FILTERS" | translate
                }}</span>
              }
            </div>
          </div>
        }
      </div>

      <div
        [style.margin-top.px]="newTasks.length ? '0' : '6'"
        class="tasks-content"
      >
        @if (isLoading$ | async) {
          <div class="m-auto">
            <app-loading-pill>{{ "LOADING" | translate }}</app-loading-pill>
          </div>
        } @else {
          @if (newTasks?.length || reviewedTasks.length) {
            <ng-container *ngrxLet="taskStatuses$ as taskStatuses">
              <ng-container *ngrxLet="departmentsColors$ as departmentsColors">
                @if (newTasks.length) {
                  <div class="new-tasks-header-container">
                    <p class="tasks-subtitle m-0">
                      {{ "TASKS.NEW_TASKS" | translate }}
                      <span>({{ newTasks.length }})</span>
                    </p>
                    <div>
                      <app-button
                        [variant]="'primary'"
                        [size]="'slim'"
                        (buttonClick)="markTasksAsReviewed(controlId)"
                      >
                        {{ "POLICIES_COVERAGE.MARK_AS_REVIEWED" | translate }}
                      </app-button>
                    </div>
                  </div>
                  <div class="box-section new-tasks-table-container">
                    <div class="d-flex label-head-container">
                      <div class="label label-status">
                        {{ "TASKS.TABLE_HEADERS.STATUS" | translate }}
                      </div>
                      <div class="label label-priority">
                        {{ "TASKS.TABLE_HEADERS.PRIORITY" | translate }}
                      </div>
                      <div class="label label-task col">
                        {{ "TASKS.TABLE_HEADERS.TASK" | translate }}
                      </div>
                      <div class="label label-date">
                        {{ "TASKS.TABLE_HEADERS.DUE_BY" | translate }}
                      </div>
                      <div class="label label-domain">
                        {{ "TASKS.TABLE_HEADERS.DOMAIN" | translate }}
                      </div>
                      <div class="label label-asset">
                        {{ "TASKS.TABLE_HEADERS.ASSET" | translate }}
                      </div>
                      <div class="label label-owner">
                        {{ "TASKS.TABLE_HEADERS.OWNER" | translate }}
                      </div>
                    </div>
                    @for (item of newTasks; track item.id) {
                      <div>
                        <app-task-item
                          [isClickable]="isClickable"
                          [controlId]="controlId"
                          [statuses]="taskStatuses"
                          [circleColor]="
                            departmentsColors &&
                            item.raci.departments.owner?.[0]?.id
                              ? departmentsColors[
                                  item.raci.departments.owner![0].id
                                ]
                              : ''
                          "
                          [itemData]="item"
                        ></app-task-item>
                      </div>
                    }
                  </div>
                }
                @if (reviewedTasks.length && newTasks.length) {
                  <div class="new-tasks-header-container">
                    <p class="tasks-subtitle m-0">
                      {{ "TASKS.REVIEWED_TASKS" | translate }}
                      <span>({{ reviewedTasks.length }})</span>
                    </p>
                  </div>
                }

                @if (reviewedTasks.length) {
                  <div class="new-tasks-table-container p-0">
                    <div class="d-flex label-head-container">
                      <div class="label label-status">
                        {{ "TASKS.TABLE_HEADERS.STATUS" | translate }}
                      </div>
                      <div class="label label-priority">
                        {{ "TASKS.TABLE_HEADERS.PRIORITY" | translate }}
                      </div>
                      <div class="label label-task col">
                        {{ "TASKS.TABLE_HEADERS.TASK" | translate }}
                      </div>
                      <div class="label label-date">
                        {{ "TASKS.TABLE_HEADERS.DUE_BY" | translate }}
                      </div>
                      <div class="label label-domain">
                        {{ "TASKS.TABLE_HEADERS.DOMAIN" | translate }}
                      </div>
                      <div class="label label-asset">
                        {{ "TASKS.TABLE_HEADERS.ASSET" | translate }}
                      </div>
                      <div class="label label-owner">
                        {{ "TASKS.TABLE_HEADERS.OWNER" | translate }}
                      </div>
                    </div>
                    @for (item of reviewedTasks; track item.id) {
                      <div>
                        <app-task-item
                          [isClickable]="isClickable"
                          [controlId]="controlId"
                          [statuses]="taskStatuses"
                          [circleColor]="
                            departmentsColors &&
                            item.raci.departments.owner?.[0]?.id
                              ? departmentsColors[
                                  item.raci.departments.owner![0].id
                                ]
                              : ''
                          "
                          [itemData]="item"
                        ></app-task-item>
                      </div>
                    }
                  </div>
                }
              </ng-container>
            </ng-container>
          } @else {
            <div class="m-auto">
              <div class="d-flex justify-content-center align-items-center">
                <svg-icon name="big-logo"></svg-icon>
                <div class="tasks-empty">
                  {{ "TASKS.NO_TASKS" | translate }}
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </ng-container>
</ng-container>
